import React from "react";
import { useNavigate } from "react-router-dom";

export default function PaymentFailed() {
  const navigate = useNavigate();
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>Payment Failed ❌</h1>
      <p>Please try again or contact support.</p>
      <button
        onClick={() => navigate("/ai-assistant")}
        style={{ marginTop: "20px", padding: "10px 20px", cursor: "pointer" }}
      >
        Back to Chat
      </button>
    </div>
  );
}
